import React, { useEffect, useState } from 'react';
import { Link, withRouter } from 'react-router-dom';

import queryString from 'query-string';

import { isEmpty } from 'lodash';

import { connect } from 'react-redux';

import { GridColumn as Column } from '@progress/kendo-react-grid';

import HtmlTooltip from '../../../components/HtmlTooltip/HtmlTooltip';
import BobTable from '../../../components/BobTable';
import ExecutiveSummaryTile from '../../../components/ExecutiveSummaryTile';

import * as BobActions from '../../../actions/bobActions';
import * as DashboardActions from '../../../actions/dashboardActions';
import * as ExecutiveSummaryActions from '../../../actions/executiveSummaryActions';

import * as classes from './ExecutiveSummarySitesTable.module.css';

const ExecutiveSummarySitesTable = ({
    bobLoading,
    companies,
    dashboardIsCurrentTimeStamp,
    expanded,
    fetchExecutiveSummarySites,
    fetchNavClients,
    fetchSingleSite,
    history,
    resetNavOptions,
    setActiveClient,
    setActiveSite,
    setActiveNavClient,
    setActiveNavEquipment,
    setActiveNavSite,
    setNavCompany,
    setNavClient,
    setNavEquipment,
    setNavSite,
    setSites,
    setZoomSite,
    sites,
    sitesMeta,
    targetNavCompany,
    ...props
}) => {
    const [data, setData] = useState([]);

    useEffect(() => {
        setData(sites);
    }, [sitesMeta]);

    const scoreCell = props => {
        let siteScore = props.dataItem.siteScore;
        if (!Number.isInteger(siteScore)) {
            siteScore = siteScore.toFixed(2);
        }
        return (
            <td className={props.className} style={props.style}>
                {siteScore + '%'}
            </td>
        );
    };

    const priorityCell = props => {
        let imgPath = '/assets/images/low.svg';
        if (props.field === 'mediumFaultCount') {
            imgPath = '/assets/images/medium.svg';
        } else if (props.field === 'highFaultCount') {
            imgPath = '/assets/images/high.svg';
        }
        return (
            <td className={props.className} style={props.style}>
                <img className={classes.Icon} src={imgPath} alt="" />
                {props.dataItem[props.field]}
            </td>
        );
    };

    const renderNavUrl = dataItem => {
        const queryValues = queryString.parse(history.location.search);

        return `site?client=${dataItem.clientId}&company=${queryValues.company}&site=${dataItem.siteId}`;
    };

    const handleNav = async dataItem => {
        let path = '/v2/dashboard/site';

        setNavClient({});
        setNavSite({});
        setNavEquipment({});
        setActiveNavClient({});
        setActiveNavSite({});
        setActiveNavEquipment({});

        const queryValues = queryString.parse(history.location.search);
        queryValues.client = dataItem.clientId;
        queryValues.site = dataItem.siteId;

        if (targetNavCompany.id !== dataItem.companyId) {
            resetNavOptions('all');
            const company = companies.find(item => item.company.id === dataItem.companyId);
            setNavCompany({
                name: company.company.name,
                id:   company.company.id
            });
            fetchNavClients(dataItem.companyId);
        } else {
            resetNavOptions('site');
        }

        const queryValuesString = queryString.stringify(queryValues);

        history.push(`${path}?${queryValuesString}`);

        await fetchSingleSite(queryValues);
    };

    const nameCell = props => {
        return (
            <td className={props.className} style={props.style}>
                <HtmlTooltip
                    information={<React.Fragment><div className={classes.Parent}>{`${props.dataItem.clientName}`}</div><div className={classes.SiteName}>{`${props.dataItem[props.field]}`}</div></React.Fragment>}
                    placement="top-start"
                    body={
                        <div style={{ overflow: 'hidden', textOverflow: 'ellipsis'}}>
                            <Link
                                to={renderNavUrl(props.dataItem)}
                                onClick={
                                    (e) => {
                                        if (!e.ctrlKey) {
                                            handleNav(props.dataItem);
                                        }
                                    }
                                }
                            >
                                {props.dataItem[props.field]}
                            </Link>
                        </div>
                    }
                />
            </td>
        );
    };

    const nameFooterCell = props => {
        return (
            <td className={props.className} style={props.style}>
                Total
            </td>
        );
    };

    const totalFooterCell = props => {
        const field = props.field || '';
        const total = data.reduce((acc, current) => acc + current[field], 0);
        let imgPath = null;

        if (props.field === 'lowFaultCount') {
            imgPath = '/assets/images/low.svg';
        } else if (props.field === 'mediumFaultCount') {
            imgPath = '/assets/images/medium.svg';
        } else if (props.field === 'highFaultCount') {
            imgPath = '/assets/images/high.svg';
        }

        return (
            <td className={props.className} style={props.style}>
                {imgPath ? <img className={classes.Icon} src={imgPath} alt="" /> : null}
                {total}
            </td>
        );
    };

    const scoreFooterCell = props => {
        const field = props.field || '';
        const total = data.reduce((acc, current) => acc + current[field], 0);
        let score = 0;
        if (data.length > 0) {
            score = (total / data.length);
            if (!Number.isInteger(score)) {
                score = score.toFixed(2);
            }
        }

        return (
            <td className={props.className} style={props.style}>
                {score + '%'}
            </td>
        );
    };

    const defaultColumns = [
        {
            key:        0,
            field:      'siteName',
            title:      'Name',
            cell:       nameCell,
            footerCell: nameFooterCell,
            id:         'siteName',
            width:      !expanded ? 'auto' : 250,
            show:       true
        },
        {
            key:        1,
            field:      'totalFaultCount',
            title:      'Faults',
            footerCell: totalFooterCell,
            id:         'faults',
            width:      75,
            show:       dashboardIsCurrentTimeStamp
        },
        {
            key:        2,
            field:      'highFaultCount',
            title:      'High',
            cell:       priorityCell,
            footerCell: totalFooterCell,
            id:         'high',
            width:      75,
            show:       dashboardIsCurrentTimeStamp
        },
        {
            key:        3,
            field:      'mediumFaultCount',
            title:      'Medium',
            cell:       priorityCell,
            footerCell: totalFooterCell,
            id:         'medium',
            width:      75,
            show:       dashboardIsCurrentTimeStamp
        },
        {
            key:        4,
            field:      'lowFaultCount',
            title:      'Low',
            cell:       priorityCell,
            footerCell: totalFooterCell,
            id:         'low',
            width:      75,
            show:       dashboardIsCurrentTimeStamp
        },
        {
            key:        5,
            field:      'siteScore',
            title:      'Score',
            cell:       scoreCell,
            footerCell: scoreFooterCell,
            id:         'scoreCeell',
            width:      80,
            show:       true
        }
    ];

    let columns = defaultColumns.filter(c => c.show).map(col => {
        return (
            <Column
                key={col.key}
                field={col.field}
                title={col.title}
                cell={col.cell}
                footerCell={col.footerCell}
                id={col.id}
                width={col.width}
            />
        );
    });
    
    const handleSiteClick = async event => {
        const { dataItem } = event;
        setZoomSite(dataItem);
        const siteList = await fetchExecutiveSummarySites(dataItem.clientId);
        setSites(siteList);
        setActiveClient({ id: dataItem.clientId, name: dataItem.clientName });
        setActiveSite({ id: dataItem.siteId, name: dataItem.siteName });
    };

    return (
        <ExecutiveSummaryTile isLoading={isEmpty(sitesMeta) || bobLoading.includes('FetchSiteScore')}>
            {isEmpty(sitesMeta) || bobLoading.includes('FetchSiteScore') ?
                <div className={classes.Loader}>
                    <img src="/assets/images/BobLoaderLarge.gif" alt="loader" />
                </div>
                :
                <BobTable
                    altStyle={true}
                    data={data}
                    columns={columns}
                    className={classes.SiteGrid}
                    isPageable={false}
                    onRowClick={handleSiteClick}
                />
            }
        </ExecutiveSummaryTile>
    );
};

const mapStateToProps = state => {
    return {
        bobLoading:                  state.bob.bobLoading,
        companies:                   state.core.companies,
        dashboardIsCurrentTimeStamp: state.dashboard.dashboardIsCurrentTimeStamp,
        sites:                       state.executiveSummary.sites,
        sitesMeta:                   state.executiveSummary.sitesMeta,
        targetNavCompany:            state.bob.targetNavCompany
    };
};

const mapDispatchToProps = ({
    ...BobActions,
    ...DashboardActions,
    ...ExecutiveSummaryActions
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ExecutiveSummarySitesTable));
